<template>
  <div>
    <Loader v-if="loader" />

    <InputText type="text" @keyup.enter="search($event)" v-model="searchString" class="inputfield w-full" placeholder="Inserisci numero fattura..." />
                
      <div v-if="fatture.length > 0">
        <DataTable :value="fatture" responsiveLayout="scroll" v-model:selection="selectedSuggests" @row-unselect="deselectedSuggest($event)" scrollHeight="400px">
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="label" header="Info"></Column>
            <Column field="saldo_modificato" header="Saldo">
              <template #body="{data}">
                  <p :class="data.saldo_modificato.toFixed(2) != 0 ? 'p-error' : ''">
                    {{data.saldo_modificato.toFixed(2)}}
                  </p>      
              </template>
            </Column>
            <Column field="pagato" header="Pagato">
              <template #body="{data}">
                  {{data.pagato.toFixed(2)}}
              </template>
            </Column>
            <Column field="totale" header="Totale fattura">
              <template #body="{data}">
                  {{data.totale.toFixed(2)}}
              </template>
            </Column>
            <Column field="modified" header="Modificato">
              <template #body="{data}">
                <small v-if="data.modified" @click="resetSaldo(data)" class="p-error p-reset"> Ripristina </small>
              </template>
            </Column>
        </DataTable>

        <div class="chip-selected-suggest mt-3 p-fluid">
          <Chips v-model="selectedSuggests" @keypress.prevent="false" @remove="removeChip($event)"> 
            <template #chip="slotProps">
                <div @click="openEditSaldoDialog(slotProps.value)" class="chip-basic">
                    <div class="title-chip">{{slotProps.value.label.split('-')[0]}}</div>
                    <span style="font-size: 12px">€ {{slotProps.value.saldo_modificato.toFixed(2)}}</span>
                    <i  class="icon-edit-saldo pi pi-pencil ml-2" style="font-size: 10px"></i>
                </div>
            </template>
          </Chips>
        </div>

          <div class="my-2 md:mt-0 flex align-items-center">
            <div class="surface-300 border-round overflow-hidden w-full  mt-1" style="height:5px">
              <div 
              class="p-bar h-full" 
              :style="{ width: percentage +'%'}"
              :class="(percentage == 100) ? 'bg-blue-500' : (percentage > 100) ? 'bg-red-500': 'bg-yellow-500'"
              >
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-4 flex justify-content-start">
              <div class="text-left">
                <p class="title-bar">ASSOCIATO</p>
                <b  class="num-bar text-yellow-500">{{associatedSum.toFixed(2)}}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-center">
              <div class="text-left">
                <p class="title-bar">RIMANENTI</p>
                <b class="num-bar p-error">{{ (Math.abs(Math.abs(notaCredito.totale_fattura) - associatedSum)).toFixed(2)}}</b>
              </div>
            </div>
            <div class="col-4 flex justify-content-end">
              <div class="text-left">
                <p class="title-bar">TOTALE</p>
                <b class="num-bar text-blue-500">{{notaCredito.totale_fattura.toFixed(2)}} </b> &euro;
              </div>
            </div>
          </div> 

        <div class="mt-3 text-right">
            <Button 
            @click="associa" 
            label="Associa movimento" 
            class="p-button-outlined" 
            />
             <!-- :disabled="Math.abs(associatedSum.toFixed(2)) != Math.abs(notaCredito.totale_fattura.toFixed(2))" 
             :class="Math.abs(associatedSum.toFixed(2)) != Math.abs(notaCredito.totale_fattura.toFixed(2)) ? 'p-button-secondary' : ' p-button-primary'"  -->
        </div>
         

      </div>
      
  </div>

   <!-- DIALOG EDIT SALDO CHIP -->
    <Dialog v-model:visible="editSaldoDialog" :style="{width: '450px'}" header="Modifica" :modal="true">
        <div class="confirmation-content">
            <div>Inserisci l'importo <br>
            <InputText type="text" v-model="temp.saldo_modificato" class="inputfield w-full mt-2" :class="{'p-invalid': validationErrors.saldo && submitted }" />
             <small class="p-error" v-if="validationErrors.saldo && submitted">Non puoi inserire un valore maggiore o uguale al saldo</small>
            </div>
        </div>
        <template #footer>
            <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="editSaldoDialog = false"/>
            <Button label="Modifica" icon="pi pi-check" class="p-button-text" @click="editSaldo" />
        </template>
    </Dialog>
    
</template>

<script>
import { ref, getCurrentInstance, watch, computed } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  emits:['movement-regularized'],
  components: {
    Loader
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  setup(props, {emit}) {
    
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const toast = useToast()
    const loader = ref(false)
    const notaCredito = ref(props.detail)
    const selectedAssociate = ref(props.type)
    const fatture = ref({})
    const searchString = ref('')
    const modified = ref([])
    const selectedSuggests = ref([])
    const submitted = ref(false);
    const validationErrors = ref({})
    const temp = ref(null)
    const editSaldoDialog = ref(false)

    
    const search = () => {
        const numeroFattura = (searchString.value || '').trim()
        const hasDigit = /\d/.test(numeroFattura)
        if (!numeroFattura || !hasDigit) {
          fatture.value = []
          selectedSuggests.value = []
          toast.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Inserisci un numero fattura valido prima della ricerca.',
            life: 3000
          })
          return
        }

        if (selectedAssociate.value != '') {
          loader.value = true
          service.getSuggerimenti(selectedAssociate.value, numeroFattura)
          .then((res) => {            
            if (res.items.length > 0) {
                const response = res.items.map((el) =>{
                  el.modified = false
                  el.saldo_modificato = el.saldo 
                  return el
                })
                verifyIsModified(response)
                fatture.value = fatture.value.filter((el) => el.saldo > 0) // only positive
            } 
          }).finally(()=>{
            loader.value = false
          })
        }
      }

      //replace duplicate fattura if same element is already modified
      const verifyIsModified = (response) => {
        fatture.value = response.map((el) => {
          const index = modified.value.findIndex( (m) => m.numero === el.numero )
          if( index != -1 ){
            return modified.value[index]
          }
          return el
        });
      }

      const deselectedSuggest = (evt) => {
        if (evt.data.modified) {
          evt.data.saldo_modificato = evt.data.saldo
          evt.data.modified = false
        }
      }

      const removeChip = (evt) => {
        const item = evt.value[0]
        if (item.modified) {
          item.saldo_modificato = item.saldo
          item.modified = false
        }
      }


      const associa = () => {
        const obj = notaCredito.value
        obj.payments = selectedSuggests.value
        service.associateNoteToPayments(obj)
        .then((res)=> {
          if (res) {
            emit('movement-regularized',{id: null})
          }
        })
      }

      const openEditSaldoDialog = (el) => {
        submitted.value = false;
        temp.value = null
        temp.value = {...el}
        editSaldoDialog.value = true
      }

      const editSaldo = () => {
        submitted.value = true;
        temp.value.saldo_modificato = temp.value.saldo_modificato.toString()
        temp.value.saldo_modificato = temp.value.saldo_modificato.replaceAll(',','.')
        temp.value.saldo_modificato = parseFloat(temp.value.saldo_modificato)
        
        selectedSuggests.value = selectedSuggests.value.filter(el => {
          if (el.numero == temp.value.numero) {
            el.saldo_modificato = temp.value.saldo_modificato
            el.modified = true
            editSaldoDialog.value = false
            return el
          } else {
            return el
          }
        })    
      }

      watch(selectedSuggests, () => {
        modified.value = selectedSuggests.value.filter(el => el.modified == true)
      })

      
      const percentage = computed(() => {
        return ((100 * Math.abs(associatedSum.value)) / Math.abs(notaCredito.value.totale_fattura)).toFixed(2)
      })
      
      const resetSaldo = (el) => {
        el.saldo_modificato =  el.saldo
        el.modified = false
      }


      
      const associatedSum = computed(() => {
        return selectedSuggests.value.reduce((old, el) =>  Math.abs(old) +  Math.abs(el.saldo_modificato), 0)
      })


    return {
        notaCredito, validationErrors, submitted, selectedAssociate,
        fatture, search, searchString, selectedSuggests, associa,
        associatedSum, openEditSaldoDialog, editSaldoDialog, editSaldo, temp, resetSaldo, 
        deselectedSuggest, removeChip, percentage, loader
    }
  },
}
</script>


